import { Icon } from "@material-ui/core";
import * as React from "react";
import TreeView from "../TreeView";

import styles from "./TreeViewItem.scss";

interface IProps {
    item: object;
    isActive: boolean;
    selectItem: (item: object) => void;
    childrenField: string;
    titleField: string;
    onResize?: () => void;
    depth: number;
    updatePath: (path: object[]) => void;
    selectedPath?: object[];
    equalityComparer?: (object1: object, object2: object) => boolean;
}

interface IState {
    item: object;
    isActive: boolean;
    selectedPath?: object[];
}

export class TreeViewItem extends React.Component<IProps, IState> {
    public childrenRef = React.createRef<HTMLDivElement>();
    public heightUpdatedState: boolean;

    public readonly DEPTH_INDENT = 14;
    public readonly ANIMATION_DURATION_MS = 300;
    public readonly RESIZE_DELAY = 50;

    constructor(props: IProps) {
        super(props);

        this.state = {
            item: props.item,
            isActive: props.isActive
        };
        
        this.hasChildren = this.hasChildren.bind(this);
        this.updateHeightDelayed = this.updateHeightDelayed.bind(this);
        this.updateHeight = this.updateHeight.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.setHeight = this.setHeight.bind(this);
        this.setAutoHeight = this.setAutoHeight.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const state: Partial<IState> = {};

        if (nextProps.item !== prevState.item) {
            state.item = nextProps.item;
        }

        if (nextProps.isActive !== prevState.isActive) {
            state.isActive = nextProps.isActive;
        }      

        if (nextProps.selectedPath !== prevState.selectedPath) {
            state.selectedPath = nextProps.selectedPath;
        }

        return state;
    }

    public hasChildren(): boolean {
        return this.state.item && this.state.item[this.props.childrenField] && this.state.item[this.props.childrenField].length > 0;
    }

    public updateHeightDelayed() {
        this.childrenRef.current && window.setTimeout(this.updateHeight);
    }

    public updateHeight() {
        if (this.childrenRef.current) {
            const childrenDiv = this.childrenRef.current;

            if (this.state.isActive) {
                const currentHeight = childrenDiv.style.height;
                childrenDiv.style.height = "auto";
                const newHeight = childrenDiv.clientHeight;
                childrenDiv.style.height = currentHeight;
                window.setTimeout(() => this.setHeight(newHeight), this.RESIZE_DELAY);
            }
            else {
                childrenDiv.style.height = childrenDiv.clientHeight + "px";
                window.setTimeout(() => this.setHeight(0), this.RESIZE_DELAY);
            }
            this.heightUpdatedState = this.state.isActive;
        }
    }

    public setHeight(height: number) {
        const newHeight = height + "px";
        if(this.childrenRef.current && this.childrenRef.current.style.height !== newHeight) {
            this.childrenRef.current.style.height = newHeight;
            height !== 0 && window.setTimeout(this.setAutoHeight, this.ANIMATION_DURATION_MS);
        }
    }

    public setAutoHeight() {
        if(this.childrenRef.current) {
            this.childrenRef.current.style.height = "auto";
        }
    }

    public selectItem() {
        this.props.selectItem(this.state.item);
    }

    public render() {
        if(this.heightUpdatedState !== this.state.isActive) {
            this.updateHeightDelayed();
        }

        return (
            <li className={`${styles.treeViewItem} ${this.state.isActive && styles.active}`}>
                <div onClick={this.selectItem} className={styles.name} style={{paddingLeft: (this.props.depth * this.DEPTH_INDENT) + "px"}}>
                    {
                        this.hasChildren() &&
                        <Icon className={styles.arrow}>keyboard_arrow_down</Icon>
                    }
                    {this.state.item[this.props.titleField]}
                </div>
                {
                    this.hasChildren() &&
                    <div ref={this.childrenRef} className={styles.children}>
                        <TreeView 
                            data={this.state.item[this.props.childrenField]} 
                            titleField={this.props.titleField} 
                            childrenField={this.props.childrenField}
                            onResize={this.updateHeightDelayed}
                            depth={this.props.depth + 1}
                            selectedPath={this.props.selectedPath}
                            updatePath={this.props.updatePath} 
                            equalityComparer={this.props.equalityComparer} />
                    </div>
                }
            </li>
        );
    }
}

export default TreeViewItem;


// WEBPACK FOOTER //
// ./src/Components/TreeView/TreeViewItem/TreeViewItem.tsx